module.exports = __webpack_public_path__ + "img/book-img.0a4d8030.png";